// extracted by mini-css-extract-plugin
export default {"root":"styles_root__98EGv","icon":"styles_icon__gMghr"};